import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class MachinesContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            content : [],
            page_content:[],
            loading : 1,
            settings:{}
        }
        

    }

    componentDidMount()
    {
         this.setState({loading:0})
           
    }


    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (
        <div>
<div class="about-area inc-video default-padding">
  <div class="container">
    <div class="row"> 
     
      <div class="about-content">
        <div class="col-md-4">
          <div class="thumb"> <img src={base_url+"assets/img/about-2.png"} alt="List of machines" /><br/><br/>
			   <img src={base_url+"assets/img/machinery-1.png"} alt="Thumb" />
			  
            
          </div>
        </div>
        <div class="col-md-8 info-content">
          <h2><strong>LIST OF MACHINES:</strong></h2>
         
          <div class="col-md-6 info-content">
            <ul>
            {this.props.machines.map((item, index) => {
               if(index > 10) return null;
              return (
              <li>{item.title}</li>
              );
})};
            </ul>
          </div>
          <div class="col-md-6 info-content">
            <ul>
            {this.props.machines.map((item, index) => {
               if(index <= 10) return null;
              return (
              <li>{item.title}</li>
              );
})};
            </ul>
          </div>
        </div>
      </div>
       
    </div>
  </div>
</div>
     
        <br />
        <br />
        </div>
       

    );
 
    }
}

export default MachinesContent;